import {
  Button,
  DescriptionList,
  List,
  Modal,
  Skeleton
} from '@efast_public/fjd-component-library';
import { useTranslation } from 'react-i18next';
import { PublicService } from '../api/models/Forwarding/Forwarding';
import { useQuery } from '@tanstack/react-query';
import { BehApiRoutes } from '../api/beh-api';

interface DetailPublicServiceModalProps {
  readonly onClose: () => void;
  readonly orgUnitId: string;
  readonly publicServiceIdentifier: string;
  readonly publicServiceName: string;
}

export function DetailPublicServiceModal({
  onClose,
  orgUnitId,
  publicServiceIdentifier,
  publicServiceName
}: DetailPublicServiceModalProps) {
  const { t } = useTranslation();
  const { data, isLoading: isLoadingData } = useQuery<Array<PublicService>>({
    queryKey: [
      BehApiRoutes.publicServicesByIdAndByOrgUnit(
        orgUnitId,
        publicServiceIdentifier
      )
    ]
  });

  return (
    <Modal open onClose={onClose}>
      <Modal.Header id="DetailPublicServiceModal-header">
        {t('detailPublicServiceModal.title')}
      </Modal.Header>

      <Modal.Content>
        <DescriptionList hasDivider={true}>
          <DescriptionList.Item
            title={t('detailPublicServiceModal.description.publicService')}
            description={
              isLoadingData ? (
                <Skeleton />
              ) : (
                publicServiceName || publicServiceIdentifier
              )
            }
            key="name"
          />
          <DescriptionList.Item
            title={t('detailPublicServiceModal.description.identifier')}
            description={isLoadingData ? <Skeleton /> : publicServiceIdentifier}
            key="identifier"
          />
          <DescriptionList.Item
            title={t('detailPublicServiceModal.description.datenmodel')}
            key="models"
            description={
              isLoadingData ? (
                <Skeleton />
              ) : (
                <List>
                  {data?.map((d, index) => (
                    <List.ListItem key={d.datamodelVersion}>
                      {d.datamodelVersion}
                    </List.ListItem>
                  ))}
                </List>
              )
            }
          />
        </DescriptionList>
      </Modal.Content>
      <Modal.Footer direction="rtl" alignment="none">
        <Button size="sm" variant="secondary-outline" onClick={onClose}>
          {t('globalNotifications.modalClose')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
